export default "__VITE_ASSET__49fb1c04__"